import { drawImage, getContext } from './images.js'
import { ResetMain, PrepareLevel, LevelNumber, levelNumber } from './main.js'
import { PlayTrack, StopTrack } from './music.js'
import { ActivateScene, DeactivateScene } from './sceneController.js'
import { Reset as DialogReset } from './scene-dialog.js'
import * as SFX from './sfx.js'
import { GetHint } from './levels.js'

let ctx = null
let titleX = 0

function Reset() {
    PlayTrack('Menu')

    setTimeout(() => {
        DialogReset(['WILDFIRE RESCUE', 'A GAME BY', 'PHIL B. GARNER'])
        ActivateScene('dialog')

        setTimeout(() => {
            DialogReset(['MADE FOR THE', 'LOWREZJAM 2023'])
            ActivateScene('dialog')

            setTimeout(() => {
                DialogReset(['TO MY WIFE', 'FOR ENCOURAGING', 'ME'])
                ActivateScene('dialog')
                setTimeout(() => {
                    DialogReset(['THANKS FOR', 'PLAYING!'])
                    ActivateScene('dialog')
                    setTimeout(() => {
                        ActivateScene('menu')
                        DeactivateScene('credits')
                    }, 9000)            
                }, 7000)        
            }, 7000)    
        }, 9000)
    }, 300)
}

function AnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    //ctx.clearRect(0, 0, 64, 64)

    drawImage('title-bg', 0, 0, { x: parseInt(titleX), y: 0, w: 64, h: 64 })
    drawImage('title-bg', parseInt(128 - titleX), 0, { x: 0, y: 0, w: 64, h: 64 })
    
    drawImage('title-text', 1, 5)

    titleX += delta * 0.1
    titleX = titleX > 128 ? 0 : titleX
}

export { AnimationFrame, Reset }